<!----添加数据列表------>
<template>
  <div class="list-operation">
    <el-table :data="tableData">
      <el-table-column
        v-if="column.isShow===false?false:true"
        v-for="(column,index) in (tableOptions && tableOptions.columns)"
        show-overflow-tooltip
        :prop="column.prop"
        align="center"
        :key="index"
        :label="column.label"
        :min-width="column.width || tableOptions.width"
      >
        <template slot-scope="scope">
          <div v-show="scope.$index < tableData.length-1">
            <span v-if="column.type =='index'">{{ scope.$index + 1 }}</span>
            <span v-else-if="column.type =='operation' && !tableOptions.disabled">
              <span
                @click="addFun(scope)"
                class="icon"
              ><i class="icon el-icon-plus"></i></span>
              <span
                @click="delFun(scope)"
                class="icon"
              ><i class="icon el-icon-minus"></i></span>
            </span>
            <el-input
             :placeholder="column.placeholder"
              v-else-if="column.type == columnType.input"
              @input="valueChange"
              v-model="scope.row[column.prop]"
              :disabled="tableOptions.disabled"
            ></el-input>
            <el-input-number
             :placeholder="column.placeholder"
              v-else-if="column.type == columnType.inputNumber"
              @change="valueChange(column,scope.row,scope.$index)"
              :precision="column.precision||null"
              v-model="scope.row[column.prop]"
              :min=0
              :disabled="tableOptions.disabled"
            ></el-input-number>
            <!--日期选择器-->
            <el-date-picker
              v-else-if="column.type === columnType.datePicker"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="scope.row[column.prop]"
              type="date"
              placeholder="选择日期"
              :disabled="tableOptions.disabled"
            ></el-date-picker>
            <!--日期时间选择器-->
            <el-date-picker
              :disabled="tableOptions.disabled"
              v-else-if="column.type === columnType.dateTimePicker"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="scope.row[column.prop]"
              placeholder="选择日期时间"
            ></el-date-picker>
            <!-- 下拉框 -->
            {{scope.row[column.prop]}}
            <el-select
              clearable
              @change="selectChange(column)"
              v-if="column.type === columnType.select"
              v-model="scope.row[column.prop]"
              placeholder="请选择"
              filterable
            >
              <el-option
                v-for="item in column.data"
                :key="item[column.uniqueKey]||item.value||item.id"
                :label="item[column.labelKey]||item.label||item.name"
                :title="item[column.labelKey]||item.label||item.name"
                :value="item[column.uniqueKey]||item.value||item.id"
              ></el-option>
            </el-select>
            <!--开关-->
            <el-switch
              v-else-if="column.type === columnType.switch"
              v-model="scope.row[column.prop]"
              @change="valueChange(column)"
            ></el-switch>
            <div
              v-else-if="column.enumData"
              v-html="$utils.getEnumItem(column,scope.row[column.prop])"
            ></div>
            <span v-else>{{ scope.row[column.prop] }}</span>
            <span
              v-if="column.type=='more'&& !tableOptions.disabled"
              @click="moreFun(column,scope.row,scope.$index)"
              class="icon"
            >
              <i class="icon el-icon-more"></i></span>
          </div>
          <div v-show="scope.$index == tableData.length-1">
            {{ scope.row[column.prop] }}
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: ["tableOptions"],
  data() {
    return {
      searchParam:{},
      columnType: this.$utils.columnType,
      tableData: [],
      tableRow: {},
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    selectChange(column){
      console.log(this.tableData,'&&&&&&&&&&&&&&&&&&&&&')
      
    },
    initData() {
      this.tableOptions.columns.map((column) => {
        if (column.prop) this.tableRow[column.prop] = "";
        if (column.type == "inputNumber")
          this.tableRow[column.prop] = undefined;
        // 获取下拉值
        if (
          column.url &&
          column.type === this.columnType.select &&
          (!column.data || column.data.length == 0)
        ) {
          column.data = [];
          this.getSelectData(column);
        }
      });
      this.$set(this.tableData, 1, this.tableRow);
      console.log(this.tableData,'&&&&&&&')
    },
    valueChange(column, row, index) {
      this.$forceUpdate();
      column.change && column.change(row, index);
    },
    //删除行
    delFun(scope) {
      if (this.tableData.length == 2) return;
      this.tableData.splice(scope.$index, 1);
    },
    //添加行
    addFun(column, row) {
      this.tableData.push(this.tableRow);
    },
    //为当前行赋值
    setColumnData(rowData, index) {
      console.log(this.tableData);
      const data = this.vertifyData(rowData);
      if (data.flag) {
        this.$message({
          message: "商品[" + data.goodsName + "]已存在",
          type: "warning",
        });
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].idx == "") {
            this.tableData.splice(i, 1);
          }
        }
        return;
      }
      //删除最后合并数据
      this.tableData.splice(this.tableData.length - 1, 1);
      rowData = { ...rowData, ...this.rowData };
      this.$set(this.tableData, index, rowData);
    },
    setCountData(rowData, index) {
      this.tableData.splice(this.tableData.length - 1, 1);
      rowData = { ...rowData, ...this.rowData };
      this.$set(this.tableData, index, rowData);
    },
    clearTableData() {
      this.tableData = [];
      this.initData();
    },
    getTableDataLength() {
      return this.tableData.length - 1;
    },
    getTabelData() {
      this.loading = true;
      this.$axios.fetchPost(this.tableOptions.url + "/list")
        .then(data => {
          this.loading = false;
          if (data.code == 200 && data.data) {
            this.tableData = data.data;
          } else {
            this.$message({ message: "请求失败！", type: "error" });
          }
        })
        .catch(err => {
          console.log(err);
          this.$message({ message: "请求失败！", type: "error" });
          this.loading = false;
        });
      let tableData = this.$utils.deepClone(this.tableData);
      tableData.splice(tableData.length - 1, 1);
      //过滤没有条码的数据
      tableData = tableData.filter((item) => {
        return (
          item[this.tableOptions.key || "barCode"] != "" &&
          item[this.tableOptions.key || "barCode"] != undefined &&
          item[this.tableOptions.key || "barCode"] != null
        );
      });
      return tableData;
    },
    getSumData() {
      return this.tableData[this.tableData.length - 1];
    },
    getSelectData(column, param, url) {
      let params = Object.assign(column.param || {}, param || {});
      // 缓存读取
      column.data = this.$utils.getDataByKey(column.url);
      if (!column.data || column.data.length == 0) {
        this.$axios
          .fetchPost((column.url || url) + "/list", params || {})
          .then((data) => {
            column.url = url || column.url;
            if (data.code == 200) {
              this.$set(column, "data", data.data);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    valueChange(column) {
      if (column.hidden || column.disabled) return;
      column.change && column.change(this.formModel);
    },
    getSpecialAttributes() {
      let rtn = true;
      this.formOptions.columns.map((item) => {
        switch (item.type) {
          case this.columnType.datetimeRange:
          case this.columnType.dateTimeRangeButton:
            rtn = this.$refs[item.prop][0].getFormData();
            if (rtn) {
              this.formModel["st" + item.prop] = rtn.split(",")[0];
              this.formModel["ed" + item.prop] = rtn.split(",")[1];
            }
        }
      });
      return rtn;
    },
    // 获取数据
    getFormModel() {
      let rtn = this.getSpecialAttributes();
      if (rtn === false) return;
      let param = Object.assign({}, this.formModel);
      let searchParam = {};
      this.formOptions.columns.map((column) => {
        if (
          param[column.prop] != "" &&
          param[column.prop] != undefined &&
          param[column.prop] != null
        ) {
          if (column.isFuzzy)
            searchParam[column.prop] = "%" + param[column.prop] + "%";
          else {
            searchParam[column.prop] = param[column.prop];
          }
        }
      });
      return searchParam;
    },
  },
};
</script>
<style>
.list-operation .icon {
  font-size: 20px;
  color: #5e57e3;
  font-weight: bolder;
  line-height: 40px;
  display: inline-block;
  margin-top: 3px;
  cursor: pointer;
  margin-left: 10px;
}

.list-operation .el-table {
  border: 1px solid #ccc;
}

.list-operation .el-table__footer-wrapper tbody td,
.list-operation .el-table__header-wrapper tbody td {
  background-color: transparent;
}

.list-operation .el-table th.is-leaf {
  border-right: 0;
}

.list-operation .el-table th,
.list-operation .el-table tr {
  line-height: 37px;
}

.list-operation .el-input-number .el-input__inner {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/business/batchAdd.vue